import { createStore } from "@stencil/store";

export const commonDynamic = createStore({
    loaded: false,
    loggedIn: false,
    customer: {},
    cartCount: 0,
    heartCount: 0,
    api: {},
    tracking: {},
    consent: {},
    compare: [],
    testing_group: null
    
} as CommonDynamicData);

export interface CommonDynamicData {
    loaded: boolean;
    loggedIn: boolean;
    guest: boolean;
    customer: CustomerData;
    cartCount: number;
    heartCount: number;
    api: ApiData;
    tracking: TrackingData;
    consent: ConsentData;
    compare: CompareData[];
    testing_group: string;
}

export interface CompareData {
    id: string;
    image: string;
    name: string;
    link: string;
}

export interface ConsentData {
    cookie: string;
    items: ConsentItem[];
    requirements: ConsentRequirement[];
    buttons: ConsentButtons;
    details: string;
}

export interface ConsentButtons {
    acceptall: string;
    settings: string;
    details: string;
    save: string;
}

export interface ConsentRequirement {
    name: string;
    consents: string[];
    message: string;
}

export interface ConsentItem {
    inputname: string;
    name: string;
    description: string;
    checked: boolean;
    disabled: boolean;
    highlighted?: boolean;
}

export interface ApiData {
    addToCart: string;

    addToFavourites: string;
    removeFromFavourites: string;
    removeAllFavourites: string;

    notifyAvailability: string;
    shippingTime: string;
    productTraits: string;
    productHistory: string;

    suggestions: string;

    negotiatePrice: string;
    newsletter: string;
    searchAutocomplete: string;

    changeLanguage: string;
    changeCurrency: string;

    inpostFrontend: string;
}

export interface TrackingData {
    tiktok: boolean;
    facebook: string;
    edrone: string;
    edroneAppId: string;
    edroneWishlistApi: string;
    pageview: string;
}

export interface CustomerData {
    email: string;
    firstName: string;
    lastName: string;
    country: string;
    countryISO2: string;
    countryISO3: string;
    city: string;
    currency: string;
    subscriber: boolean;
    phone: string;
}

export interface SubscriptionData {
    email: string;
    name?: string;
    subscriber: boolean;
    place: string;
}

